import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/components/content/quiz-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.5.19_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.51.1_react-dom@19_vd3wfn2xfois7wdetnjnkvkwnu/node_modules/next/dist/client/app-dir/link.js");
